import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSeoTags, buildWebPageJsonLd } from '../../hooks/useSeoTags';
import './LegalPage.css';

const TermsPage: React.FC = () => {
  const { t } = useTranslation('legal');

  // Legal pages are public + indexable; meta keeps SERP entries informative.
  const termsTitle = t('terms.title');
  const termsDescription = t('terms.sections.acceptance.content', {
    defaultValue: 'Loopy Terms of Service.',
  });
  const seoTags = useSeoTags({
    title: termsTitle,
    description: termsDescription,
    canonical: '/terms',
    jsonLd: buildWebPageJsonLd({
      url: '/terms',
      name: termsTitle,
      description: termsDescription,
      breadcrumbs: [
        { name: 'Loopy', url: '/' },
        { name: termsTitle, url: '/terms' },
      ],
    }),
  });

  return (
    <div className="legal-page">
      {seoTags}
      <div className="legal-container">
        <div className="legal-header">
          <h1>{t('terms.title')}</h1>
          <p className="legal-updated">{t('terms.lastUpdated')}: 2025-01-17</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>{t('terms.sections.acceptance.title')}</h2>
            <p>{t('terms.sections.acceptance.content')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('terms.sections.services.title')}</h2>
            <p>{t('terms.sections.services.content')}</p>
            <ul>
              <li>{t('terms.sections.services.items.0')}</li>
              <li>{t('terms.sections.services.items.1')}</li>
              <li>{t('terms.sections.services.items.2')}</li>
              <li>{t('terms.sections.services.items.3')}</li>
              <li>{t('terms.sections.services.items.4')}</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>{t('terms.sections.account.title')}</h2>
            <p>{t('terms.sections.account.content')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('terms.sections.payment.title')}</h2>
            <p>{t('terms.sections.payment.content')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('terms.sections.intellectualProperty.title')}</h2>
            <p>{t('terms.sections.intellectualProperty.content')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('terms.sections.userContent.title')}</h2>
            <p>{t('terms.sections.userContent.content')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('terms.sections.prohibited.title')}</h2>
            <p>{t('terms.sections.prohibited.content')}</p>
            <ul>
              <li>{t('terms.sections.prohibited.items.0')}</li>
              <li>{t('terms.sections.prohibited.items.1')}</li>
              <li>{t('terms.sections.prohibited.items.2')}</li>
              <li>{t('terms.sections.prohibited.items.3')}</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>{t('terms.sections.termination.title')}</h2>
            <p>{t('terms.sections.termination.content')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('terms.sections.disclaimer.title')}</h2>
            <p>{t('terms.sections.disclaimer.content')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('terms.sections.changes.title')}</h2>
            <p>{t('terms.sections.changes.content')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('terms.sections.contact.title')}</h2>
            <p>{t('terms.sections.contact.content')}</p>
            <p className="legal-email">support@loopyai.app</p>
          </section>
        </div>

        <div className="legal-footer">
          <Link to="/privacy" className="legal-link">{t('common.viewPrivacy')}</Link>
          <Link to="/" className="legal-link">{t('common.backToHome')}</Link>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
